import React, { ReactElement } from "react";
import useStyles from "./styles";

export interface CobeeLinkProps {
  disabled?: boolean;
  customStyle?: string;
  className?: string;
  linkText: string;
  handleClick?: () => void;
}

export default function CobeeLink({
  disabled,
  customStyle,
  className,
  linkText,
  handleClick,
}: CobeeLinkProps): ReactElement {
  const { linkStyle, disabledStyle } = useStyles();
  return (
    <button
      type="button"
      disabled={disabled}
      className={
        customStyle || `${className} ${linkStyle} ${disabled && disabledStyle}`
      }
      onClick={handleClick}
    >
      {linkText}
    </button>
  );
}
